import { api, type DenemeSatiri, type DenemeDilimiSorgusu } from "./api";
import type { DenemeKimlik } from "@koclukpanel/contracts";

// F-EXM-14 — ortak istemci oturum, hata ve istek kimliği davranışını korur.
export function havuzYayinevleri() {
  return api<Array<{ id: string; name: string }>>("/deneme/yayinevleri");
}

export function havuzYayineviEkle(name: string) {
  return api<{ id: string; name: string }>("/deneme/yayinevleri", {
    yontem: "POST",
    govde: { name },
  });
}

export function havuzKaydet(govde: unknown) {
  return api<{ id?: string; onIzleme?: boolean; soruSayisi?: number; kazanimSayisi?: number }>(
    "/deneme/havuz",
    { yontem: "POST", govde },
  );
}

export function denemeGirisiAc(
  denemeId: string,
  ogrenciId: string,
  eylem: "yeniden-ac" | "kilidi-ac",
  govde: unknown,
) {
  return api<{ acildi: boolean }>(
    `/deneme/${encodeURIComponent(denemeId)}/atamalar/${encodeURIComponent(ogrenciId)}/${eylem}`,
    { yontem: "POST", govde },
  );
}

// F-EXM-15 — eski denemelerin kimlik alanları boş olabilir; yeni havuz kimliği listede de taşınır.
export type HavuzDenemeSatiri = DenemeSatiri & {
  [K in keyof Omit<DenemeKimlik, "kind">]?: DenemeKimlik[K] | null;
};
export type HavuzListeSorgusu = {
  sayfa: number;
  boyut: number;
  arama?: string;
  dilim?: DenemeDilimiSorgusu;
} & Partial<Omit<DenemeKimlik, "kind">>;

export function havuzDenemeleriSayfali(sorgu: HavuzListeSorgusu) {
  return api<{ toplam: number; sayfa: number; boyut: number; denemeler: HavuzDenemeSatiri[] }>(
    "/denemeler/sayfali",
    { sorgu },
  );
}
